import React, { useContext } from "react";
import { Alert, Box, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { DataGrid, Icon } from "../../../components";
import { LoginContext } from "../../../context/login-context";

const FARM_REQUIRED_BANNER =
  "To ensure a successful invoice upload against a Sub Account, it should have at least one Farm configured.";

const ACCOUNT_TYPE_LABELS = {
  SUB_ENTITY: "Sub Account",
  FARM: "Farm",
};

const FarmsBlock = ({ farms, onAddFarm, canAddSubEntity }) => {
  const hasSubEntity = farms?.some((f) => f.account_type === "SUB_ENTITY");
  const hasFarms = farms?.some((f) => f.account_type === "FARM");

  const { state: userData } = useContext(LoginContext);

  const navigate = useNavigate();

  const columns = [
    {
      field: "name",
      headerName: "Name",

      renderCell: (params) => {
        const isSubEntity = params.row?.account_type === "SUB_ENTITY";

        return (
          <>
            {params.row?.name}
            {isSubEntity && (
              <>
                <IconButton>
                  <Icon icon="ChevronRight" />
                </IconButton>
              </>
            )}
          </>
        );
      },
    },
    {
      field: "account_type",
      headerName: "Account Type",
      width: 140,
      valueGetter: (_, row) =>
        ACCOUNT_TYPE_LABELS[row?.account_type] || row?.account_type || "",
    },
    {
      field: "address",
      headerName: "Location",
      renderCell: (params) => {
        const getAddress =
          params?.row?.address &&
          params?.row?.city &&
          params?.row?.state &&
          params?.row?.zip
            ? `${params?.row?.address}, ${params?.row?.city}, ${params?.row?.state} ${params?.row?.zip}`
            : "--";

        return <>{getAddress}</>;
      },
    },

    {
      field: "action",
      headerName: "",
      sortable: false,
      align: "right",
      renderCell: () => {
        return (
          <>
            <IconButton
              onClick={() => {
                navigate("/account/farm/");
              }}
            >
              <Icon icon="ChevronRight" />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
      {!hasFarms && (
        <Alert severity="info" sx={{ width: "100%" }}>
          {FARM_REQUIRED_BANNER}
        </Alert>
      )}
      <DataGrid
        toolbarBtnVisible={userData?.isValmontUser}
        toolbarTitle={
          hasSubEntity && !hasFarms
            ? "Sub Accounts"
            : !hasSubEntity && hasFarms
              ? "Farms"
              : "Sub Accounts/Farms"
        }
        toolbarBtnTitle={`+ Add New ${canAddSubEntity ? "Sub Account/" : ""}Farm`}
        toolbarOnClick={onAddFarm}
        rows={farms}
        columns={columns}
        onRowClick={(params) => {
          navigate(
            `/${params.row?.account_type === "FARM" ? "farm" : "sub-account"}/${encodeURIComponent(params.row.name)}`,
            { state: { farm: params.row } }
          );
        }}
        sx={{
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
        }}
      />
    </Box>
  );
};

export default FarmsBlock;
